"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../../material/index");

var _overview = _interopRequireDefault(require("./overview/overview"));

var _detail = _interopRequireDefault(require("./detail/detail"));

var _index2 = require("../../../utils/index");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _linechart_styles = _interopRequireDefault(require("./linechart_styles"));

var _linechart_definition = _interopRequireDefault(require("./linechart_definition"));

var _definecomponent = require("../../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// material
// charts
// utils
// styles
// definition

/* ========== ~~~~~~~~~~ EXPORT : CHART : LINE ~~~~~~~~~~ ========== */


var LineChart = (0, _reactJss.default)(_linechart_styles.default)(function (props) {
  // make sure parent container have a defined height when using responsive component, otherwise height will be 0 and no chart will be rendered.
  var handleChartVariant = function handleChartVariant() {
    switch (props.type) {
      case 'detail':
        return _react.default.createElement(_detail.default, {
          yType: props.yType,
          xType: props.xType,
          data: props.data
        });

      case 'overview':
      default:
        return _react.default.createElement(_overview.default, {
          yType: props.yType,
          xType: props.xType,
          data: props.data
        });
    }
  };

  var handleLoadVariant = function handleLoadVariant() {
    switch (props.loading) {
      case true:
        return null;

      default:
        return _react.default.createElement(_index.NoDataState, null);
    }
  };

  var handleNoData = function handleNoData() {
    return props.data && props.data.length ? handleChartVariant() : handleLoadVariant();
  };

  var hasText = function hasText() {
    return props.label || props.value ? true : false;
  };

  var hasToolTip = function hasToolTip() {
    return props.tooltip ? true : false;
  };

  var handleClick = function handleClick(e) {
    return props.moreDetails ? props.moreDetails.action() : null;
  };

  var renderMoreDetails = function renderMoreDetails() {
    return !props.moreDetails ? null : _react.default.createElement("div", {
      className: "details"
    }, _react.default.createElement(_index.Link, {
      type: props.moreDetails.type ? props.moreDetails.type : "internal",
      name: (0, _index2.generateName)(props.label),
      text: props.moreDetails.text ? props.moreDetails.text : "View Details",
      color: props.moreDetails.color ? props.moreDetails.color : "supporting",
      action: props.moreDetails.action ? props.moreDetails.action : console.log('PLEASE PROVIDE A MOREDETAILS ACTION'),
      icon: "external-link-alt",
      iconRight: true
    }));
  };

  return _react.default.createElement("div", {
    className: "chart linechart ".concat((0, _index2.generateClasses)(props), " ").concat(props.classes.linechart, " hasDetails-").concat(props.moreDetails ? props.moreDetails : false, " name-").concat(props.name ? props.name : (0, _index2.generateName)(props.label)),
    onClick: handleClick
  }, _react.default.createElement("div", {
    className: "data"
  }, hasText() || hasToolTip() ? _react.default.createElement("div", {
    className: "info"
  }, _react.default.createElement("div", {
    className: "text"
  }, _react.default.createElement("div", {
    className: "label"
  }, props.label), _react.default.createElement("div", {
    className: props.loading ? "loading" : "value"
  }, props.loading ? _react.default.createElement("div", {
    className: "loading"
  }, "Loading...", _react.default.createElement(_index.Loader, {
    name: 'loader'
  })) : props.value)), hasToolTip() ? _react.default.createElement(_index.Tip, {
    content: props.tooltip
  }) : null) : null, _react.default.createElement("div", {
    className: "visualization"
  }, handleNoData())), renderMoreDetails());
});
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */

(0, _definecomponent.defineComponent)(LineChart, _linechart_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = LineChart;
exports.default = _default;